import { UserGroupDTO } from '../../../dto/user-group/user-group.dto';

/** Org setting: hide groups with no members at the current location (default on). */
export const GROUPS_HIDE_EMPTY_AT_LOCATION_KEY =
  'groups_hide_empty_at_location';

export function isGroupsHideEmptyAtLocationEnabled(
  data: Record<string, unknown> | undefined | null
): boolean {
  if (!data) {
    return true;
  }
  const v = data[GROUPS_HIDE_EMPTY_AT_LOCATION_KEY];
  if (v === undefined || v === null) {
    return true;
  }
  return v === true || v === 'true' || v === 1;
}

export function filterUserGroupsForLocationDisplay(
  items: UserGroupDTO[],
  hideEmptyAtLocation: boolean
): UserGroupDTO[] {
  if (!hideEmptyAtLocation) {
    return items;
  }
  return items.filter((g) => (g.member_count ?? 0) > 0);
}

/** Gruppe-kalender on a location page requires at least one relevant group. */
export function locationHasGroupCalendarGroups(
  groupsAtLocation: UserGroupDTO[],
  hideEmptyAtLocation: boolean
): boolean {
  if (groupsAtLocation.length === 0) {
    return false;
  }
  if (!hideEmptyAtLocation) {
    return true;
  }
  return groupsAtLocation.some((g) => (g.member_count ?? 0) > 0);
}

export function resolveOrgIdFromUser(
  user: Record<string, unknown> | null | undefined
): number | null {
  if (!user) {
    return null;
  }
  const orgId =
    user['organizations_id'] ??
    (user['user_info'] as Record<string, unknown> | undefined)?.[
      'organizations_id'
    ];
  if (orgId == null) {
    return null;
  }
  const n = typeof orgId === 'number' ? orgId : parseInt(String(orgId), 10);
  return Number.isFinite(n) ? n : null;
}
